module.exports = __webpack_public_path__ + "assets/img/kv-ad9fe7e5.jpg";